import React from "react";
import { NavMenu } from "@shopify/app-bridge-react";
import { DI, DIProps } from "../Core";
import { Link as ReactRouterLink } from "react-router-dom";

const NavMenuWrapper: React.FC<DIProps> = (props) => {
  const { redux } = props;

  const showFullMenu =
    redux?.account?.target?.shein?.length > 0 && Number(redux?.basic?.stepActive) === 4;


  if (process.env.REACT_APP_PROD !== "1" || window.top === window.self) {
    return null;
  }

  return (
    <NavMenu>
      <a href="/panel/user/dashboard" rel="home">
        Home
      </a>
      {showFullMenu && (
        <>
          <ReactRouterLink to="/panel/user/dashboard" key="Dashboard">
            Dashboard
          </ReactRouterLink>
          <ReactRouterLink to="/panel/user/templates" key="Templates">
            Templates
          </ReactRouterLink>
          <ReactRouterLink to="/panel/user/products" key="Listings">
            Listings
          </ReactRouterLink>
          <ReactRouterLink to="/panel/user/certifications" key="Certificates">
            Certificates
          </ReactRouterLink>
          <ReactRouterLink to="/panel/user/orders" key="Orders">
            Orders
          </ReactRouterLink>
          <ReactRouterLink to="/panel/user/settings" key="Settings">
            Settings
          </ReactRouterLink>
          <ReactRouterLink to="/panel/user/subscription" key="Subscription">
            Subscription
          </ReactRouterLink>
        </>
      )}
    </NavMenu>
  );
};

export default DI(NavMenuWrapper, {
  stateNeeded: true,
}); 